import { leadSourceDefaultValue } from "client/services/hubspot-service/hubspot-constants";
import { CONTACT_SALES_HUBSPOT_FORM_ID } from "client/services/hubspot-service/contact-form-config";
export default {
    portalId: "5945317",
    formId: CONTACT_SALES_HUBSPOT_FORM_ID,
    source: leadSourceDefaultValue,
    withPrivacyNotice: true
};
